import type { Routes } from '../views/Routes';
import type { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import StyledText from '../components/StyledText';

type Props = BottomTabScreenProps<Routes, 'MediaPage'>;
export default function MediaPage({ navigation, route }: Props): React.ReactElement {
    return (<StyledText>Not available</StyledText>)
}
